import React, { Component } from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames';
import '@/companys/ttl/assets/styles/components/detail-center/financials_detail_dialog.scss'

import { utilsFunction, Converter } from '@/helpers/functions';
import { ACTION_TYPE } from "@/constants/w-socket";
import { LOADING_TYPE } from '@/constants/app';
import { WS_LANG_KEY } from "@/constants/app";
import { stockActions } from "@/actions/trading/stock.action";

import RadioOptions from '@/components/TabHeader/RadioOptions';
import LoadingLayer from '@/components/Spinner/LoadingLayer'; 
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';

import Finances from './Finances';

class FinancialsDetailDialog extends Component {
    constructor(props){
        super(props)
        this.state = {
            load:true,
            headerStock:'',
            quoteData:'',
            marketID:'',
            InstrumentID: '',
            blockSelectIndex:0,
            Radiogroup:[
                {label:'market_all',value:'all'},
                {label:'market_annual',value:'annual'},
                {label:'market_interim',value:'interim'},
                {label:'market_q1',value:'Q1'},
                {label:'market_q3',value:'Q3'},
            ],
            key:0,
            blockSelect:['market_finances','market_income_statement','market_balance_sheet','market_cash_flow_statement'],
            FinancialsLeftData:['market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            FinancialData:null,
            deepFinancialData:null,
            IncomeLeftData:['market_turnover','market_cost_of_sales','market_gross_profit','market_selling_expenses','market_administrative_expenses/labor_cost','market_depreciation_and_amortization','market_interest_expense','market_research_and_development_expenses','market_fair_value_changes','market_other_operating_profit_and_loss','market_operating_profit','market_financing_cost','market_other_non_operating_profit_and_loss','market_earning_before_tax','market_tax','market_earning_after_tax','market_minority_profit','market_share_equity_without_minority_interest','market_basic_earnings_per_share','market_diluted_earning_per_share','market_dividend','market_dividend_per_share'],
            IncomeStatementData:null,
            deepIncomeStatementData:null,
            BalanceSheetLeftData:['market_current_assets','market_cash_and_short_term_investments','market_total_advance_receivable','market_inventory','market_total_current_assets',
            'market_non_current_assets','market_property_plant_and_equipment','market_land_use_right','market_goodwill','market_intangible_assets','market_associated_company_interest_and_interests_in_joint_venture','market_total_non_current_assets','market_total_assets',
            'market_current_liabilities','market_total_advance_payments_payable','market_total_short_term_interest_bearing_liabilities','market_total_current_liabilities',
            'market_non_current_liabilities','market_total_long_term_interest_bearing_debt','market_long_term_accounts_payable','market_deferred_tax','market_total_non_current_liabilities','market_total_liabilities',
            'market_owners_equity','market_equiry','market_reserves','market_total_share_equiry_without_minority_interest','market_minority_shareholders_equity','market_tital_owners_equity',],
            BalanceSheetData:null,
            deepBalanceSheetData:null,
            CashFlowStatementLeftData:['market_profit_before_tax','market_cash_from_operating_activities','market_net_cash_provided_by_operating_activities','market_net_cash_used_in_investing_activities','market_net_cash_provided_by_financing_activities','market_effect_of_rate','market_begining_period_cash_and_net_cash','market_cash_at_the_end_and_net_cash',],
            CashFlowStatementData:null,
            deepCashFlowStatementData:null,
            headData:null,
            deepheadData:null
            // FinancialsLeftDatasssss:[
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            //     ['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
            // ]
        }
    }
    render() {
        const { language } = this.props
        const {blockSelect,blockSelectIndex,Radiogroup,headData,
            load,headerStock,quoteData,
            FinancialsLeftData,FinancialData,
            IncomeLeftData,IncomeStatementData,
            BalanceSheetLeftData,BalanceSheetData,
            CashFlowStatementLeftData,CashFlowStatementData
           } = this.state
        return (
            <div className='financial_detail_dialog'>
                <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG}/>
                {/* header */}
                <div className='stock_header' >
                    <div className='headerStock' >{headerStock}</div>
                    <div className={classnames('quoteData',quoteData.classStyle)} >
                        <div className='quoteData_last'>{quoteData.last} </div>
                        <div className='changeValue'>{quoteData.changeValue}{quoteData.changePercent}</div>
                    </div>
                </div>
                {/* blockSelect */}
                <div className='blockSelect'>
                    { blockSelect.map((item,index)=>{
                        return ( <div key={item} onClick={() =>this.blockSelectClick(index)} className={blockSelectIndex == index ? 'active_block_select' : 'inactive_block_select'} >{language[item]}</div> )
                    })}
                </div>
                <div className='radio_group'>
                    <RadioOptions key={this.state.key} options={Radiogroup} onChange={(opt) => this.handleSelectRadioType(opt)}></RadioOptions>
                </div>
                {/* Finances Table */}
                { blockSelectIndex == 0 && <Finances Data={FinancialData}
                blockSelectIndex = {blockSelectIndex}
                    leftData={FinancialsLeftData}
                    headData = {headData}
                    handleLeftClassName={this.handleFinancialLeftClassName}
                    handleDataClassName={this.handleFinancialDataClassName}/>}
                {/*  Income Statement Table */}
              { blockSelectIndex == 1 && <Finances Data={IncomeStatementData }
                blockSelectIndex = {blockSelectIndex}
                    leftData={IncomeLeftData}
                    headData = {headData}
                    handleLeftClassName = {this.handleIncomeStatementLeftClassName}
                    handleDataClassName={this.handleIncomeStatementDataClassName} />}
                {/* Balance Sheet Table */}
                { blockSelectIndex == 2 && <Finances Data={BalanceSheetData}
                leftData={BalanceSheetLeftData}
                headData = {headData}
                blockSelectIndex = {blockSelectIndex}
                handleLeftClassName = {this.handleBalanceSheetLeftClassName}
                handleDataClassName={this.hanldeBalanceSheetDataClassName}/> }
                {/* CashFlow Statement  Table */}
                { blockSelectIndex == 3 && <Finances Data={CashFlowStatementData}
                leftData={CashFlowStatementLeftData}
                headData = {headData}
                blockSelectIndex = {blockSelectIndex}
                handleLeftClassName = {this.hanldeCashFlowStatementLeftClassName}
                handleDataClassName={this.handleFinancialDataClassName}/> }
                </div>
        )
    }
    componentDidMount(){
        const { marketParams ,index } = this.props;
        const { marketID, stockCode } = marketParams;
        this.setState({marketID: marketID, InstrumentID: stockCode ,blockSelectIndex:index},()=>{this.getFinancialsData(),this.getHeaderData()})
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
          return 
        }
      }
    blockSelectClick = (index) => {
        const {deepheadData,deepFinancialData,deepIncomeStatementData,deepBalanceSheetData,deepCashFlowStatementData} = this.state
        this.setState({blockSelectIndex:index,
                        key:index,
                        headData:deepheadData,
                        FinancialData:deepFinancialData,
                        IncomeStatementData:deepIncomeStatementData,
                        BalanceSheetData:deepBalanceSheetData,
                        CashFlowStatementData:deepCashFlowStatementData
        })
    }

    handleSelectRadioType = (opt) =>{
        const {deepFinancialData,deepIncomeStatementData,deepBalanceSheetData,deepCashFlowStatementData,blockSelectIndex,deepheadData}= this.state
        const {language} = this.props
        switch(opt.value){
            case 'all' :this.setState({headData:deepheadData}) 
                break;
            case 'annual':
                let aHead = deepheadData.filter((item)=>{
                    return item[0].includes(language.market_annual)
                })
                this.setState({headData:aHead})
                break;
            case 'interim':
                let iHead = deepheadData.filter((item)=>{
                    return item[0].includes(language.market_interim)
                })
                this.setState({headData:iHead})
                break;
            case 'Q1':
                let q1Head = deepheadData.filter((item)=>{
                    return item[0].includes(language.market_q1)
                })
                this.setState({headData:q1Head})
                break;
            case 'Q3':
                let q3Head = deepheadData.filter((item)=>{
                    return item[0].includes(language.market_q3)
                })
                this.setState({headData:q3Head})
                break;
        }
        switch(blockSelectIndex){
            case 0:
                switch(opt.value){
                    case 'all':
                        this.setState({FinancialData:deepFinancialData})
                        break;
                    case 'annual':
                        let  FAnnual = deepFinancialData.filter((item)=>{
                            return item[0].includes(language.market_annual)
                        })
                        this.setState({FinancialData:FAnnual,})
                        break;
                    case 'interim':
                        let Finterim = deepFinancialData.filter((item)=>{
                            return item[0].includes(language.market_interim)
                        })
                        this.setState({FinancialData:Finterim})
                        break;
                    case 'Q1':
                        let Fq1 = deepFinancialData.filter((item)=>{
                            return item[0].includes(language.market_q1)
                        })
                        this.setState({FinancialData:Fq1})
                        break;
                    case 'Q3':
                        let Fq3 = deepFinancialData.filter((item)=>{
                            return item[0].includes(language.market_q3)
                        })
                        this.setState({FinancialData:Fq3})
                        break;
                }
            break;
            case 1:
                switch(opt.value){
                    case 'all':
                        this.setState({IncomeStatementData:deepIncomeStatementData})
                        break;
                    case 'annual':
                        let  IAnnual = deepIncomeStatementData.filter((item)=>{
                            return item[0].includes(language.market_annual)
                        })
                        this.setState({IncomeStatementData:IAnnual})
                        break;
                    case 'interim':
                        let IInterim = deepIncomeStatementData.filter((item)=>{
                            return item[0].includes(language.market_interim)
                        })
                        this.setState({IncomeStatementData:IInterim})
                        break;
                    case 'Q1':
                        let Iq1 = deepIncomeStatementData.filter((item)=>{
                            return item[0].includes(language.market_q1)
                        })
                        this.setState({IncomeStatementData:Iq1})
                        break;
                    case 'Q3':
                        let Iq3 = deepIncomeStatementData.filter((item)=>{
                            return item[0].includes(language.market_q3)
                        })
                        this.setState({IncomeStatementData:Iq3})
                        break;
                }
            break;
            case 2:
                switch(opt.value){
                    case 'all':
                        this.setState({BalanceSheetData:deepBalanceSheetData})
                        break;
                    case 'annual':
                        let  BAnnual = deepBalanceSheetData.filter((item)=>{
                            return item[0].includes(language.market_annual)
                        })
                        this.setState({BalanceSheetData:BAnnual})
                        break;
                    case 'interim':
                        let BInterim = deepBalanceSheetData.filter((item)=>{
                            return item[0].includes(language.market_interim)
                        })
                        this.setState({BalanceSheetData:BInterim})
                        break;
                    case 'Q1':
                        let Bq1 = deepBalanceSheetData.filter((item)=>{
                            return item[0].includes(language.market_q1)
                        })
                        this.setState({BalanceSheetData:Bq1})
                        break;
                    case 'Q3':
                        let Bq3 = deepBalanceSheetData.filter((item)=>{
                            return item[0].includes(language.market_q3)
                        })
                        this.setState({BalanceSheetData:Bq3})
                        break;
                }
            break;
            case 3:
                switch(opt.value){
                    case 'all':
                        this.setState({CashFlowStatementData:deepCashFlowStatementData})
                        break;
                    case 'annual':
                        let  BAnnual = deepCashFlowStatementData.filter((item)=>{
                            return item[0].includes(language.market_annual)
                        })
                        this.setState({CashFlowStatementData:BAnnual})
                        break;
                    case 'interim':
                        let BInterim = deepCashFlowStatementData.filter((item)=>{
                            return item[0].includes(language.market_interim)
                        })
                        this.setState({CashFlowStatementData:BInterim})
                        break;
                    case 'Q1':
                        let Bq1 = deepCashFlowStatementData.filter((item)=>{
                            return item[0].includes(language.market_q1)
                        })
                        this.setState({CashFlowStatementData:Bq1})
                        break;
                    case 'Q3':
                        let Bq3 = deepCashFlowStatementData.filter((item)=>{
                            return item[0].includes(language.market_q3)
                        })
                        this.setState({CashFlowStatementData:Bq3})
                        break;
                }
            break;
        }
        
    }
    handleFinancialLeftClassName = (index) => {
        const {language} = this.props
        if(language.key != 'EN'){
            return 'no_en_finances_black_block'
        }else {
            return 'finances_black_block'
        }
    }
    handleFinancialDataClassName = (indexdata) =>{
        switch(indexdata){
            case 0:
                return 'black_block';
            default:
                return 'white_block';
        }
    }
    handleIncomeStatementLeftClassName = (index) => {
        const {language} = this.props
        if(language.key != 'EN'){
            switch (index) {
                case 0: case 2: case 10 : case 13: case 15: case 18:
                    return 'no_en_income_black_no_border';
                default:
                    return 'no_en_income_black_block'
            }
        } else {
            switch (index) {
                case 0: case 2: case 10 : case 13: case 15: case 18:
                return 'income_black_no_border';
            default:
                return 'income_black_block'
        }
        }
        
    }
    handleIncomeStatementDataClassName = (indexdata) => {
        switch (indexdata) {
            case 1: case 3: case 11 : case 14: case 16: case 19:
                return 'no_border';
            default:
                return 'white_block'
        }
    }
    handleBalanceSheetLeftClassName =(index) => {
        const {language} = this.props
        if(language.key != 'EN'){
            switch(index){
                case 0: case 5: case 13: case 17: case 23:
                    return 'no_en_blance_sheet_no_border'
                default :
                return 'no_en_blance_sheet_black_block'
            }
        } else {
            switch(index){
                case 0: case 5: case 13: case 17: case 23:
                return 'blance_sheet_no_border'
            default :
            return 'blance_sheet_black_block'
        }
        }
        
    }
    hanldeBalanceSheetDataClassName = (indexdata) => {
        switch(indexdata){
            case 1: case 6: case 14: case 18: case 24:
                return 'blance_sheet_data_no_border';
            default :
            return 'white_block'
        }
    }
    hanldeCashFlowStatementLeftClassName = (index) => {
        const {language} = this.props
        if(language.key != 'EN'){
            return 'no_en_cash_flow_statement_black_block'
        }
        return 'cash_flow_statement_black_block'
    }

    handleResPush = (acceptData,data) =>{
        data.forEach((item)=>{
            acceptData.push(item)
        })
    }
    handleQuarter = (DateData) => {
        const {language} = this.props
        if(DateData){
            let month =  DateData.split('-')[1]
            let year = DateData.split('-')[0]
            let Q = ''
        switch (month){
            case '01': case '02': case '03':
                Q = language.market_q1
                break;
            case '04': case '05': case '06':
                Q = language.market_interim
                break;
            case '07': case '08': case '09':
                Q = language.market_q3
                break;
            case '10': case '11': case '12':
                Q = language.market_annual
        }
        return year + ' ' + Q
        }
    }
     // 保留小数点后x位 与 是否要在最后加上'%'
    Decimal(num, x, Percentage = false) {
        if(num){
             let placeholder = ' '
        if (Percentage) placeholder = '%'
        else placeholder = ' '
        return num.split('.')[0] + '.' + num.split('.')[1].substr(0, x) + placeholder
        }
    }

     // 数值格式转换方法(加单位)
     NumericalTransformation(num) {  
         if(num){
             //或许可以改为迭代的好看点
        const language = utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
        let negative = ''
        if(num.includes('-')){  //截取 ‘-’ 防止影响数值的长度而影响显示的数值 没截取可能会显示：比如-126623.0，显示为 0.00亿
             negative = '-'
            num = num.substr(1,(num.length + 1))
        }
        if (language == 'en') {     //判断语言
            if (num.length >= 10) {   //判断加B还是加M  
                if((num / 1000000000).toString().includes('.')){
                    return negative + (num / 1000000000).toString().split('.')[0] + '.' + (num / 1000000000).toString().split('.')[1].substr(0, 3) + 'B'
                }else {
                    return negative + (num / 1000000000) + 'B'
                }
            }else if (num.length >= 7) {
                if((num / 1000000).toString().includes('.')){
                    return negative + (num / 1000000).toString().split('.')[0] + '.' + (num / 1000000).toString().split('.')[1].substr(0, 3) + 'M'
                }else {
                    return negative + (num / 1000000) + 'M'
                }
            } else return num
        } else {
            if (num.length >= 9) {   //判断加亿还是加万
                if((num / 100000000).toString().includes('.')){
                    return  negative + (num / 100000000).toString().split('.')[0] + '.' + (num / 100000000).toString().split('.')[1].substr(0, 2) + '亿'
                } else {
                    return negative + (num / 100000000) + '亿'
                }
            } else if (num.length >= 5) {
                if((num / 10000).toString().includes('.')){
                    return negative + (num / 10000).toString().split('.')[0] + '.' + (num / 10000).toString().split('.')[1].substr(0, 2) + '万'
                }else {
                  return negative +  (num / 10000) + '万'
                }
            } else return num
        }
      }
    }
    
    getFinancialsData(){
        this.setState({load:true})
        let { marketID, InstrumentID } = this.state
        const {language} = this.props
        marketID = Converter.mappingWebSocketMarket(marketID);
        let stockID = InstrumentID
        stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        const params = {
            msgType: ACTION_TYPE.SECURITY_FINANCIAL_REPORT,
            symbol: { exchangeID: Converter.mappingWebSocketMarket(marketID), key: stockID },
            language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
        }
        let resDataSort = []
        let FinancialData = []
        let IncomeStatementData = []
        let BalanceSheetData = []
        let CashFlowStatementData = []
        let headData = []
        this.props.getFinancialsData(params,res => {
            if(res){
                if(res.data.S1)    this.handleResPush(resDataSort,res.data.S1)
                if(res.data.S2)    this.handleResPush(resDataSort,res.data.S2)
                if(res.data.S3)    this.handleResPush(resDataSort,res.data.S3)
                if(res.data.S4)    this.handleResPush(resDataSort,res.data.S4)
                resDataSort.sort((a,b)=>{
                    return b.basicInfo.yearEndDate - a.basicInfo.yearEndDate
                })
                resDataSort.forEach((item,index)=>{
                    let DateData =   formatFunctions.dataFormat(item.basicInfo.yearEndDate,dataType.LONG_DATE) 
                    headData[index] = []
                    headData[index].push(this.handleQuarter(DateData))
                    FinancialData[index] = []
                    FinancialData[index].push(this.handleQuarter(DateData))
                    FinancialData[index].push(DateData.split('-')[0] + '-'  + DateData.split('-')[1])
                    FinancialData[index].push(this.Decimal(item.financialRatio.earnPerShare,2))
                    FinancialData[index].push(this.Decimal(item.financialRatio.netAssetPerShare,2))
                    let DebtRatio = ''
                    let otherCurrentLiabilities = ''
                    let TotalAssets = ''
                    otherCurrentLiabilities = (Number(item.balanceSheet?.payables) + Number(item.balanceSheet?.otherLiabilities)) +
                    (Number(item.balanceSheet?.longTermDebt) + Number(item.balanceSheet?.otherCurrentLiabilities))
                    TotalAssets = (Number(item.balanceSheet?.cashAndShortTermFunds) + Number(item.balanceSheet?.otherCurrentAssets)) +
                    (Number(item.balanceSheet?.fixedAssets) + Number(item.balanceSheet?.intangibleAssets) + Number(item.balanceSheet?.otherAssets))
                    if(TotalAssets != 0){
                        if((otherCurrentLiabilities / TotalAssets * 100).toString().includes('.'))
                    DebtRatio = (otherCurrentLiabilities / TotalAssets * 100).toString().split('.')[0]  + '.'  + (otherCurrentLiabilities / TotalAssets * 100).toString().split('.')[1].substr(0,2) + '%'
                    else DebtRatio = '-'
                    } else DebtRatio = '-'
                    FinancialData[index].push(DebtRatio)
                    FinancialData[index].push(this.Decimal(item.financialRatio.returnOnEquity,2,true))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.returnOnTotalAssets,2,true))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.currentRatio,2,true))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.quickRatio,2,true))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.inventoryTurnover,2))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.operatingMargin,2,true))  
                    FinancialData[index].push(this.Decimal(item.financialRatio.profitMarginBeforeTax,2,true))  
                    ////////////////////////////////////////////////////////////////////
                    IncomeStatementData[index] = []
                    IncomeStatementData[index].push(this.handleQuarter(DateData))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.turnover))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.costOfSales))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.grossProfit))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.sellingExpenses))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.administrativeExpenses))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.depreciation))
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.randDExpenses))
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.operatingProfitLoss))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.financingCost))
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.profitLossBeforeTaxation))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.taxation))
                    if(!item.profitLoss.profitLossBeforeTaxation && !item.profitLoss.taxation) 
                    IncomeStatementData[index].push('-') 
                    else IncomeStatementData[index].push(this.NumericalTransformation(((Number(item.profitLoss.profitLossBeforeTaxation) - Number(item.profitLoss.taxation))).toString()))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.minorityInterests))
                    IncomeStatementData[index].push(this.NumericalTransformation(item.profitLoss.netProfitLoss))
                    IncomeStatementData[index].push(item.profitLoss.basicEarnPerShare)
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push('-')
                    IncomeStatementData[index].push(item.profitLoss.dividendPerShare)
                    //////////////////////////////////////////////
                    BalanceSheetData[index] = []
                    BalanceSheetData[index].push(this.handleQuarter(DateData))
                    //////////
                    BalanceSheetData[index].push(' ')
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.cashAndShortTermFunds))
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.inventory))
                    if(!item.balanceSheet.cashAndShortTermFunds && !item.balanceSheet.inventory && !item.balanceSheet.otherCurrentAssets) 
                    BalanceSheetData[index].push('-')
                    else BalanceSheetData[index].push(this.NumericalTransformation(((Number(item.balanceSheet.cashAndShortTermFunds) + Number(item.balanceSheet.inventory) + Number(item.balanceSheet.otherCurrentAssets)).toString())))
                    /////////
                    BalanceSheetData[index].push(' ')
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.intangibleAssets))
                    BalanceSheetData[index].push('-')
                    if(!item.balanceSheet.fixedAssets && !item.balanceSheet.intangibleAssets) 
                    BalanceSheetData[index].push('-')
                    else BalanceSheetData[index].push(this.NumericalTransformation(((Number(item.balanceSheet.fixedAssets) + Number(item.balanceSheet.intangibleAssets) + Number(item.balanceSheet.otherAssets)).toString())))
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.totalAssets))
                    //////////
                    BalanceSheetData[index].push(' ')
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push('-')
                    if(!item.balanceSheet.payables && !item.balanceSheet.otherLiabilities)  
                    BalanceSheetData[index].push('-')
                    else BalanceSheetData[index].push(this.NumericalTransformation(((Number(item.balanceSheet.payables) + Number(item.balanceSheet.otherLiabilities)).toString())))
                    /////////
                    BalanceSheetData[index].push(' ')
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.longTermDebt))
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push('-')
                    if(!item.balanceSheet.longTermDebt && !item.balanceSheet.otherCurrentLiabilities) 
                    BalanceSheetData[index].push('-')
                    else BalanceSheetData[index].push(this.NumericalTransformation(((Number(item.balanceSheet.longTermDebt) + Number(item.balanceSheet.otherCurrentLiabilities)).toString())))
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.totalLiabiliites))
                    /////////
                    BalanceSheetData[index].push(' ')
                    BalanceSheetData[index].push('-')
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.reserve))
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.shareHoldersEquity))
                    BalanceSheetData[index].push(this.NumericalTransformation(item.balanceSheet.minorityEquity))
                    if(!item.balanceSheet.shareHoldersEquity && !item.balanceSheet.minorityEquity) 
                    BalanceSheetData[index].push('-')
                    else BalanceSheetData[index].push(this.NumericalTransformation(((Number(item.balanceSheet.shareHoldersEquity) + Number(item.balanceSheet.minorityEquity)).toString())))
                    /////////////////////////////////////
                    CashFlowStatementData[index] = []
                    CashFlowStatementData[index].push(this.handleQuarter(DateData))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.profitLoss.profitLossBeforeTaxation))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.increaseInCash))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.netCashFlowFromOperating))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.netCashFlowFromInvesting))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.netCashFlowFromFinancing))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.netCashFlowDueToChangeInExchangeRate))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.cashAtBeginningOfYear))
                    CashFlowStatementData[index].push(this.NumericalTransformation(item.cashFlow.cashAtEndOfYear))
                })
                this.setState({FinancialData,deepFinancialData:FinancialData,IncomeStatementData,deepIncomeStatementData:IncomeStatementData,
                    BalanceSheetData,deepBalanceSheetData:BalanceSheetData,CashFlowStatementData,deepCashFlowStatementData:CashFlowStatementData,
                    headData:headData,deepheadData:headData , load:false},()=>{})
            }
        })
    }
    getHeaderData(){
        const {language} = this.props
        let { marketID, InstrumentID } = this.state
        let stockID = InstrumentID
        stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
        if (stockID > -1) {
            stockID = this.state.InstrumentID.substr(stockID)
        }
        let headerStock = ''
        let name = ''
        this.props.getQuote({ exchangeID: marketID, instrumentID: stockID },res =>{
            const quoteData = Converter.computeQuoteData(res);
            if(language.key == 'CN') name = res.scName 
            else if(language.key == 'EN') name = res.name
            else name = res.tcName
            headerStock = res.exchangeID + '.' + InstrumentID + '    ' + name
             this.setState({headerStock,quoteData})
        })
    }
}
FinancialsDetailDialog.defaultProps = {
    blockSelectIndex: 0
}

export default connect( 
    state => ({
        language: state.app.language,
        marketParams: state.trade.marketParams,
    }),
    dispatch => ({
        getFinancialsData:(p,c) => stockActions.getFinancialsDataAction(p,c),
        getQuote: (p, res) => stockActions.enquireInstrumentInfoAction(p, res),
}))(FinancialsDetailDialog)
